import { isAndroid, useGetReservationByIdQuery } from "@stepapp/core";
import { Block, palette, SafeAreaView, SvgIcon, spacing, Touchable, Typography } from "@stepapp/ui";
import { useLocalSearchParams, useRouter } from "expo-router";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";
import { UpdatePayment } from "../../../src/components";

const ReservationPaymentMethodModal = () => {
  const { t } = useTranslation();
  const { back } = useRouter();
  const { reservationId = "" } = useLocalSearchParams<{ reservationId: string }>();

  const { data, refetch } = useGetReservationByIdQuery({
    variables: { orderId: reservationId, isCustomerApp: true },
    onCompleted(data) {
      setPaymentMethodId(data.getReservationById.payment?.paymentMethodId || "");
    },
  });

  const [paymentMethodId, setPaymentMethodId] = useState("");

  const selectPaymentMethod = useCallback((id: string) => {
    setPaymentMethodId(id);
  }, []);

  const handleGoBack = useCallback(() => {
    back();
  }, [back]);

  return (
    <SafeAreaView edges={["bottom"]} style={styles.container}>
      {!isAndroid && (
        <Touchable onPress={handleGoBack}>
          <Block alignCenter justifyCenter style={styles.backIcon}>
            <SvgIcon color={palette.common.black} name={"chevron-left"} size={28} />
          </Block>
        </Touchable>
      )}

      <Block paddingVertical={2}>
        <Typography variant="sectionTitle">{t("screens.serviceSummary.paymentMethod")}</Typography>
      </Block>

      <Block flex={1}>
        <UpdatePayment
          changePayment
          bundleName={data?.getReservationById?.bundle?.name}
          cycleDuration={data?.getReservationById?.subscription?.periodicity?.cycleDuration}
          paymentId={data?.getReservationById.payment?.id}
          paymentMethodId={paymentMethodId}
          price={data?.getReservationById?.price}
          selectPaymentMethod={selectPaymentMethod}
          setSheetVisible={back}
          refetchReservation={refetch}
          startDate={data?.getReservationById?.startDate}
          reservationId={reservationId}
        />
      </Block>
    </SafeAreaView>
  );
};

export default ReservationPaymentMethodModal;

const styles = StyleSheet.create({
  backIcon: {
    backgroundColor: palette.secondary.grey,
    borderRadius: spacing.unit * 2.5,
    height: spacing.unit * 5,
    width: spacing.unit * 5,
    marginTop: spacing.unit * 2,
  },
  container: {
    flex: 1,
    paddingBottom: spacing.unit * 5,
  },
});
